import { Link } from 'react-router-dom';
import { featuredAnime } from '@/mocks/anime';

export default function HotRecommend() {
  return (
    <section id="hot-recommend" className="max-w-[1280px] mx-auto px-4 md:px-6 py-10">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500">高分好评，大家都在看的热门动漫</p>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {featuredAnime.map((anime) => (
          <Link
            key={anime.id}
            to={`/article/${anime.slug}`}
            className="group cursor-pointer"
          >
            <div className="relative overflow-hidden rounded-xl aspect-[3/4] mb-3">
              <img
                src={anime.cover}
                alt={anime.title}
                title={`${anime.title} - 51动漫网`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-2 left-2">
                <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
                  anime.status === '连载中'
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-foreground-600 text-background-50'
                }`}>
                  {anime.status}
                </span>
              </div>
              <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-950/70 backdrop-blur-sm rounded-full px-2 py-0.5">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                <span className="text-xs text-background-50 font-medium">{anime.rating}</span>
              </div>
            </div>
            <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1">
              {anime.title}
            </h3>
            <p className="text-xs text-foreground-400 mt-1">{anime.updateChapter}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}